import { useCallback, useEffect, useMemo } from 'react';
import { useOldStrategicPerformanceStateContext } from '../contexts/OldStrategicPerformanceStateContext';

export const useOldStrategicPerformanceStore = <T,>(
  key: string,
  initialValue: T
): [T, (value: T | ((val: T) => T)) => void] => {
  const { state, updateKey, loading } = useOldStrategicPerformanceStateContext();

  const value = useMemo(() => {
    const existing = state[key];
    if (existing === undefined || existing === null) {
      return initialValue;
    }
    return existing as T;
  }, [state, key, initialValue]);

  useEffect(() => {
    if (!loading && (state[key] === undefined || state[key] === null) && initialValue !== undefined) {
      updateKey(key, initialValue).catch(err => {
        console.error('Failed to initialize strategic performance store key:', err);
      });
    }
  }, [loading, state, key, initialValue, updateKey]);

  const setValue = useCallback((newValue: T | ((val: T) => T)) => {
    const resolvedValue =
      typeof newValue === 'function'
        ? (newValue as (val: T) => T)(value)
        : newValue;
    updateKey(key, resolvedValue).catch(err => {
      console.error('Failed to update strategic performance store:', err);
    });
  }, [key, updateKey, value]);

  return [value, setValue];
};

